import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import {
  Col, Row,
  Button,
  Form, FormGroup,
  Input, Label,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap';
import { SketchPicker } from 'react-color'

import MultilingualInput from 'components/MultiLangInput/v2'
import Lang from 'Lang/General';

function IndustryForm({
  data,
  mode,
  fairs,
  onSubmit,
  onClose,
  clientID,
  selectedStages
}) {
  const [formData, setFormData] = useState({
    title: {
      de: '',
      en: '',
      it: '',
      nl: ''
    },
    description: {
      de: '',
      en: '',
      it: '',
      nl: ''
    },
    color: '',
    fair_id: null,
    is_active: true,
    client_id: clientID
  })

  useEffect(() => {
    if (mode === 'edit' && selectedStages) {
      setFormData({
        ...selectedStages
      })
    }
  }, [selectedStages])

  const onChangeField = (key, val) => setFormData({
    ...formData,
    [key]: val
  })

  return (
    <>
      <ModalHeader toggle={() => onClose()} >
        {Lang[mode === 'create' ? 'CREATE_STAGE' : 'UPDATE_STAGE'][data.languageReducer.userSettings.admin_panel_language]}</ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col lg={12}>
              <FormGroup>
                <MultilingualInput
                  label={Lang['TITLE'][data.languageReducer.userSettings.admin_panel_language]}
                  selectedLanguage={data.languageReducer.userSettings.admin_panel_language}
                  value={formData.title}
                  valueName='title'
                  parent={formData}
                  onChangeValue={(parentName, formDataValue) => setFormData(formDataValue)}
                />
              </FormGroup>
            </Col>
            <Col lg={12}>
              <FormGroup>
                <MultilingualInput
                  label={Lang['DESCRIPTION'][data.languageReducer.userSettings.admin_panel_language]}
                  selectedLanguage={data.languageReducer.userSettings.admin_panel_language}
                  value={formData.description}
                  valueName='description'
                  parent={formData}
                  onChangeValue={(parentName, formDataValue) => setFormData(formDataValue)}
                />
              </FormGroup>
            </Col>
            <Col lg={6}>
              <FormGroup>
                <Label>
                  {Lang['COLOR'][data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <SketchPicker
                  color={formData.color}
                  onChangeComplete={(color) => {
                    onChangeField('color', color.hex)
                  }}
                />
              </FormGroup>
            </Col>
            <Col lg={6}>
              <FormGroup>
                <Label>
                  {Lang['FAIRS'][data.languageReducer.userSettings.admin_panel_language]}
                </Label>
                <Input
                  type={"select"}
                  value={formData.fair_id}
                  onChange={e => onChangeField('fair_id', e.target.value)}
                >
                  <option></option>
                  {fairs.map((data) => (
                    <option key={data.id} value={data.id}>
                      {data.name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button
          color='primary'
          onClick={() => onSubmit({
            ...formData,
            fair_id: +formData.fair_id
          })}>
          {Lang['SUBMIT'][data.languageReducer.userSettings.admin_panel_language]}
        </Button>
      </ModalFooter>
    </>
  )
}

export default IndustryForm